import type { RedoListItem } from "../../arbiter-components/list/redo-list";

/**
 * Fuse search keys for filter value options. `value` covers items whose value
 * is the display string, while `text` / `badge.text` cover list items (e.g.
 * tag badges) whose `value` is a typed object — without these, Fuse stringifies
 * the object to "[object Object]" and the display name is not searchable.
 */
export const ARRAY_STRING_FILTER_SEARCH_KEYS = ["value", "text", "badge.text"];

/**
 * Selected values lead the dropdown only while the search box is empty. Once
 * the merchant types, the search matches lead instead, and selected values
 * that don't match stay at the end of the list, where
 * `mergeSelectedListItems` appends them.
 */
export function shouldSortSelectedFirst(searchText: string): boolean {
  return searchText.trim() === "";
}

export const SELECTED_SECTION_ID = Symbol("selected-section");

/** Moves selected items to the top under a heading, keeping each group's order. */
export function groupSelectedFirst(
  items: RedoListItem<string>[],
  selectedItems: RedoListItem<string>[],
  heading: string,
): RedoListItem<string>[] {
  const selectedIds = new Set(selectedItems.map((item) => item.id));
  const selected = items.filter((item) => selectedIds.has(item.id));
  if (selected.length === 0) {
    return items;
  }
  return [
    { id: SELECTED_SECTION_ID, value: "", type: "section", text: heading },
    ...selected,
    ...items.filter((item) => !selectedIds.has(item.id)),
  ];
}
